import type { DomainInfo } from '@ballerine/digital-footprint-schemas';
import { Calendar } from 'lucide-react';

import { ReportWrapper } from '../../report-shared/components';
import { DomainInfo as DomainDetails } from '../../composites';

type DomainDetailsSectionProps = {
  domainInfo?: DomainInfo | null;
};

export const DomainDetailsSection = ({ domainInfo }: DomainDetailsSectionProps) => {
  return (
    <ReportWrapper
      title="Domain Details"
      Icon={Calendar}
      tooltip="WHOIS data and domain registration information analysis."
      showTooltip={false}
    >
      <DomainDetails domainInfo={domainInfo} />
    </ReportWrapper>
  );
};
